<template>
  <div class="labelmaster-div">
    <div class="main-content-div">
      <div>
        <div class="logo-div">
          <img :src="xiaobiaoLogo" alt="" width="50px" height="50px" />
          <div class="text-row">ePrinter</div>
        </div>
        <div class="bannerBox">
          <img class="bannerImg" :src="xiaobiaoDetail" alt="药准点" />
        </div>
      </div>
      <div class="button-row">
        <div class="download-btn odd" @click="toDownload('google')">
          <img class="btn-icon" :src="goole2x" alt="android" />Google play
        </div>
        <div class="download-btn odd" @click="toDownload('android')">
          <img class="btn-icon" :src="Android2x" alt="android" />Android App Store (China only)
        </div>
        <div class="download-btn" @click="toDownload('iphone')">
          <img class="btn-icon" :src="iPhone2x" alt="iphone" />App Store
        </div>
        
      </div>
    </div>

    <div class="TipsPage" v-show="showMask">
      <img class="arrowing" :src="arrowing" alt="" />
      <div class="conterBox">
        <p style="text-indent:-42px;">1，点击右上角“...”</p>
        <p>2，选择“在浏览器打开”</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "labelmaster",
  props: {},
  data() {
    return {
      arrowing: require("@/assets/images/arrowing.png"),
      showMask: false,
      xiaobiaoLogo: require("@/assets/images/logo@2x.png"),
      xiaobiaoDetail: require("@/assets/images/interface_en@2x.png"),
      iPhone2x: require("@/assets/images/iPhone2x.png"),
      Android2x: require("@/assets/images/Android2x.png"),
      goole2x:require("@/assets/images/goole@2x.png")
    };
  },
  created() {
    this.checkDevice(); //检验设备，是否在微信、企业微信打开
  },
  methods: {
    checkDevice() {
      const ua = navigator.userAgent.toLowerCase();
      const isWinxin = ua.indexOf("micromessenger") != -1;
      this.showMask = isWinxin;
    },
    toDownload(type) {
      const url =
        type === "iphone"
          ? "https://apps.apple.com/us/app/eprinter/id6470786132?platform=iphone"
          :type==="google"?"https://play.google.com/store/apps/details?id=com.quyin.eprinter":"https://oss.qu-in.com/apk/ePrinter.apk";
      window.location.href = url;
    },
  }
};
</script>

<style lang="less" src="./index.less" scoped />



// WEBPACK FOOTER //
// src/view/home/index.vue